// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-form-item[data-v-ba1a0bfc] {\r\n    border-bottom: 2px solid #eee;\n}\r\n", ""]);
// Exports
module.exports = exports;
